import { yupResolver } from '@hookform/resolvers/yup';
import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';

import { gridSizeMdLg6, newTarjetasSchema } from '@/shared';
import {
  CreateTarjetaParams,
  useCreateTarjeta,
  useUpdateTarjeta
} from '@/shared/actions/erp/administration/tarjeta.actions'

import {
  
  CustomNumberTextField,
  CustomTextField,
  SampleCheckbox,
  SingleFormBoxScene,
} from '@/shared/components/ui';
import { Tarjeta } from '@/shared/interfaces';
import { Grid } from '@mui/material';

export interface SaveTarjetaInterface {
  titlePage: string;
  editTarjeta?: Tarjeta;
}

const returnUrlTarjetaPage = '/parametrizacion/tarjetas';

type SaveFormData = CreateTarjetaParams;

const SaveTarjeta: React.FC<SaveTarjetaInterface> = ({ titlePage, editTarjeta }) => {
  const navigate = useNavigate();
  const [shrink, setShrink] = useState(false);

  ///* mutations
  const createTarjetaMutation = useCreateTarjeta({
    navigate,
    returnUrl: returnUrlTarjetaPage,
  });
  const updateTarjetaMutation = useUpdateTarjeta(navigate, returnUrlTarjetaPage);

  ///* form
  const form = useForm<SaveFormData>({
    resolver: yupResolver(newTarjetasSchema as any),
    defaultValues: {
      estado: true,
    },
  });
  const {
    handleSubmit,
    reset,
    formState: { errors, isValid },
  } = form;

  ///* handlers
  const onSave = () => {
    if (!isValid) return;

    ///* upd
    if (editTarjeta?.id_tarjeta) {
      return updateTarjetaMutation.mutate({
        id: editTarjeta.id_tarjeta,
        data: form.getValues() as any, // percent
      });
    }

    ///* create
    return createTarjetaMutation.mutate(form.getValues() as any);
  };

  ///* effects
  useEffect(() => {
    if (editTarjeta) {
      setShrink(true);
      reset({
        ...editTarjeta,
      });
    }
  }, [editTarjeta]);

  return (
    <SingleFormBoxScene
      titlePage={titlePage}
      onCancel={() => {
        navigate(returnUrlTarjetaPage);
      }}
      onSave={handleSubmit(onSave)}
    >
     {/*  <CustomTextField
        label="Código"
        name="codigo"
        control={form.control}
        defaultValue={form.getValues().codigo || ''}
        error={errors.codigo}
        helperText={errors.codigo?.message ?? ''}
        size={gridSizeMdLg6}
        disabled={!!editTarjeta?.codigo}
        shrink={shrink}
      /> */}
      <CustomTextField
        label="Nombre"
        name="nombre"
        control={form.control}
        defaultValue={form.getValues().nombre || ''}
        error={errors.nombre}
        helperText={errors.nombre?.message ?? ''}
        size={gridSizeMdLg6}
        shrink={shrink}
      />
      <CustomNumberTextField
        label="numero referencia"
        name= "numero_referencia"
        ///register={register('numero_referencia')}
        error={errors.numero_referencia}
        helperText={errors.numero_referencia?.message ?? ''}
        size={gridSizeMdLg6}
        shrink={shrink}
        control={form.control}
        defaultValue={form.getValues().numero_referencia || ''}
      />
      
      {/* ====== state ====== */}
      <Grid item {...gridSizeMdLg6}>
        <SampleCheckbox
          label="Estado"
          name="estado"
          control={form.control}
          defaultValue={!!form.getValues().estado}
          isState
        />
      </Grid>

    </SingleFormBoxScene>
  );
};

export default SaveTarjeta;
